import type { FactionId } from "@frontier/content/factions";
import { FactionInsignia } from "./FactionInsignia";
import { pressHandlers } from "./press-handlers";
import "./account.css";

export function AccountButton({
  factionId,
  onOpen,
}: {
  factionId: FactionId | null;
  onOpen: () => void;
}) {
  return (
    <button
      className="account-button"
      aria-label="Аккаунт и фракция"
      {...pressHandlers(onOpen)}
    >
      <FactionInsignia factionId={factionId} />
    </button>
  );
}
